import { Link, useNavigate } from "react-router-dom";
import { GiSoundOn } from "react-icons/gi";
import { FaSearch } from "react-icons/fa";
import { RxHamburgerMenu } from "react-icons/rx";
import { LiaTimesSolid } from "react-icons/lia";
import { useState } from "react";
import { motion, Variants, AnimatePresence } from "framer-motion";
import { headerData, domain } from "../../data";
import { FaLessThanEqual } from "react-icons/fa6";
import bullbear from "../../assets/bullbear.jpg";
import DrawerUtils from "../UtilComponents/DrawerUtils";
import { Box } from "@mui/material";
import { MdCandlestickChart } from "react-icons/md";
import logo from "../../assets/vel-logo.jpg";

// import { domain } from "../../data";

// const itemVariants: Variants = {
//   open: {
//     opacity: 1,
//     y: 0,
//     transition: { type: "spring", stiffness: 300, damping: 24 },
//   },
//   closed: { opacity: 0, y: 20, transition: { duration: 0.2 } },
// };

export default function Header() {
	const [showNav, setShowNav] = useState(false);
	const navigate = useNavigate();

	const changePage = (pg) => {
		if (pg.length === 0) {
			setShowNav(false);

			navigate("/");
		} else {
			setShowNav(!showNav);
			navigate(`/${pg}`);
		}
	};

	const content = (
		<header className=" w-full  bg-black  bg-opacity-75  text-white   z-50  fixed     top-0 ">
			<section className="w-[90%]  mx-auto  h-[4rem]  flex justify-between  items-center">
				<button
					onClick={() => {
						changePage("");
					}}
					className="flex justify-center  items-center    rounded-md    p-1">
					<img
						src={logo}
						alt="bullbearLogo"
						style={{ width: "3rem", height: "3rem" }}
					/>

					{/* <h2
						style={{ textShadow: "0 0 0 10px  black " }}
						className="font-black text-shadow-lg/50 text-white rounded-[1rem] bg-gray-600 px-[0.6rem]  py-[0.3rem]  uppercase  text-[0.8rem]  tracking-wide">
						{domain}

						<MdCandlestickChart className="inline-block   bg-white    text-red-500    mb-[0.2rem]  ml-[0.2rem] rounded-full" />
					</h2> */}
				</button>
				<Link
					to="/en/login"
					className="text-[0.8rem]  underline  md:hidden  px-[0.8rem]  py-[0.3rem]     bg-white    text-black  rounded-md     ">
					Sign in
				</Link>
				<Link
					to="/en/register"
					className="text-[0.8rem]  underline  md:hidden   px-[0.8rem]  py-[0.3rem]  border-2 border-white   text-white   rounded-md      ">
					Sign up
				</Link>
				{/* <Link to="/en/login" className="header-link">
					Sign in
				</Link>
				<Link to="/en/register" className="header-link">
					Sign up
				</Link> */}

				{headerData.map((data) => (
					<Link
						to={data.url}
						key={data.id}
						className="    header-link   hidden md:block   ">
						{data.name}
					</Link>
				))}
				<Box onClick={() => setShowNav(!showNav)} className="md:hidden">
					{/* {showNav ? (
						<LiaTimesSolid className="text-[1.3rem]" />
					) : (
						<RxHamburgerMenu className="text-[1.3rem]" />
					)} */}

					<DrawerUtils />
				</Box>
			</section>
		</header>
	);

	return content;
}
